import { _ as __assign } from './chunks/bundle-CxLxJCBu.js';
import React__default from 'react';
import { C as ChannelListProvider } from './chunks/bundle-DaPdVbQX.js';
import ChannelListUI from './ChannelList/components/ChannelListUI.js';
import '@sendbird/chat/groupChannel';
import './chunks/bundle-mqagBpi9.js';
import './chunks/bundle-DKdROCX_.js';
import './chunks/bundle-kFa80LJe.js';
import './chunks/bundle-DP3z2QNm.js';
import './chunks/bundle-DXFVroy5.js';
import '@sendbird/uikit-tools';
import './withSendbird.js';
import './chunks/bundle-DRpjMk0B.js';
import './chunks/bundle-BA9oFJ90.js';
import './utils/message/getOutgoingMessageState.js';
import './chunks/bundle-DiK8ifY3.js';
import './chunks/bundle-C-nZYnmy.js';
import 'react-dom';
import './chunks/bundle-d1cOX5nv.js';
import './chunks/bundle-DS1EhNtb.js';
import './chunks/bundle-Ci-RNuvu.js';
import './ui/IconButton.js';
import './ui/Button.js';
import './chunks/bundle-CjJk57u5.js';
import './ui/Icon.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import './chunks/bundle-DdJ9pMWn.js';
import './useSendbirdStateContext.js';
import './chunks/bundle-BzR1dD25.js';
import './ui/SortByRow.js';
import './chunks/bundle-D2HQ66dZ.js';
import './ChannelList/components/ChannelPreview.js';
import './chunks/bundle-w2yLrIlh.js';
import './chunks/bundle-CewnJAub.js';
import './ui/Loader.js';
import './chunks/bundle-jrZGOZ7u.js';
import './chunks/bundle-Dq0ggazV.js';
import './chunks/bundle-BdE39Lk2.js';
import './chunks/bundle-QsOiwa9F.js';
import './GroupChannel/components/TypingIndicator.js';
import './ui/Badge.js';
import './ui/ChannelAvatar.js';
import './chunks/bundle-DOfhjbKd.js';
import './ui/ImageRenderer.js';
import './chunks/bundle-C_zEpfCP.js';
import './chunks/bundle-BlguTwHI.js';
import './ui/MentionUserLabel.js';
import './chunks/bundle-B5pWUwTI.js';
import './ui/TextButton.js';
import './chunks/bundle-B5157rdG.js';
import './chunks/bundle-AmtSwuex.js';
import './GroupChannelList/components/GroupChannelPreviewAction.js';
import './chunks/bundle-QYB3Mk61.js';
import './GroupChannelList/components/GroupChannelListHeader.js';
import './ui/Header.js';
import './EditUserProfile.js';
import './EditUserProfile/context.js';
import './EditUserProfile/components/EditUserProfileUI.js';
import './chunks/bundle-D9MeorzH.js';
import './ui/Input.js';
import './ui/PlaceHolder.js';
import './chunks/bundle-CzHaD4PM.js';
import './chunks/bundle-AJS7Mngy.js';
import '@sendbird/chat/message';
import './chunks/bundle-BjAeG049.js';
import './ChannelList/components/AddChannel.js';
import './chunks/bundle-CBHlCwa8.js';
import './CreateChannel.js';
import './CreateChannel/components/CreateChannelUI.js';
import './chunks/bundle-CYoJWHCE.js';
import './sendbirdSelectors.js';
import './CreateChannel/components/InviteUsers.js';
import './ui/UserListItem.js';
import './ui/MutedAvatarOverlay.js';
import './ui/Checkbox.js';
import './ui/UserProfile.js';
import './CreateChannel/components/SelectChannelType.js';

/**
 * @deprecated This component is deprecated and will be removed in the next major update.
 * Please use the `GroupChannelList` component from '@sendbird/uikit-react/GroupChannelList' instead.
 * For more information, please refer to the migration guide:
 * https://docs.sendbird.com/docs/chat/uikit/v3/react/introduction/group-channel-migration-guide
 */
var ChannelList = function (props) {
    return (React__default.createElement(ChannelListProvider, __assign({}, props),
        React__default.createElement(ChannelListUI, __assign({}, props))));
};

export { ChannelList as default };
//# sourceMappingURL=ChannelList.js.map
